import React from 'react';
import { KeyboardCodes } from '../Helpers';

const BackButton = ({ className = '', label = 'Back', onClick, onKeyDown }) => {
    const internalKeyDown = e => {
        if ([KeyboardCodes.ENTER, KeyboardCodes.SPACE].includes(e.keyCode)) {
            onKeyDown();
        }
    };

    return (
        <button
            className={`clx-step__button-back ${className}`}
            type="button"
            onClick={onClick}
            onKeyDown={e => internalKeyDown}
        >
            <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="-6 0 24 24">
                <polyline
                    stroke="#181818"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2px"
                    points="10 1 1 10 10 19"
                />
            </svg>
            {label}
        </button>
    );
};

export default BackButton;
